class ExpandedAddToCart extends window.BAO.CustomElement({
  SuperClass: HTMLDialogElement,
}) {
  connectedCallback () {
    super.connectedCallback()

    this.state = {
      productData: {},
    }
  }

  setupListeners () {
    super.setupListeners()

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.EXPANDED_ADD_TO_CART_TRIGGER.CLICK,
      this.handleOpen.bind(this),
    )

    this.listeners.add(
      this.els.close.element,
      'click',
      this.handleClose.bind(this),
    )

    this.addEventListener('click', event => {
      if (event.target === this && this.open) {
        this.handleClose(event)
      }
    })

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.AFTER_ADD_FROM_FORM,
      this.handleClose.bind(this),
    )
  }

  handleOpen (event) {
    event.preventDefault()

    this.state.productData = event.detail.productData

    this.renderParts()
    this.loadImage()
  }

  renderParts () {
    this.els.card.element.innerHTML = this.productCardTemplate(
      this.state.productData.product,
    )
    this.els.variants.element.innerHTML = this.productVariantsTemplate(
      this.state.productData.variants,
    )
  }

  loadImage () {
    const img = new Image()
    img.src = this.state.productData.product.image
    img.onload = () => {
      this.els.card.element.querySelector('img').src = img.src
      setTimeout(() => {
        this.showModal()
        this.lockScroll()
      }, 50)
    }
  }

  handleClose (event) {
    event.preventDefault()

    this.close()
    this.unlockScroll()
  }

  lockScroll () {
    document.body.style.top = `-${window.scrollY}px`
    document.body.style.position = 'fixed'
    document.body.style.width = '100%'
  }

  unlockScroll () {
    const scrollY = document.body.style.top
    document.body.style.position = ''
    document.body.style.top = ''
    window.scrollTo(0, parseInt(scrollY || '0') * -1)
  }

  productCardTemplate (product) {
    return `
      <div class="mod-ExpandedAddToCart_Card">
        <div class="mod-ExpandedAddToCart_CardImage">
          <img data-src="${product.image}" alt="${product.title}">
        </div>
        <div class="mod-ExpandedAddToCart_CardContent">
          <h3 class="mod-ExpandedAddToCart_CardTitle">
            ${product.title}
          </h3>
          <p class="mod-ExpandedAddToCart_CardPrice">
            ${product.final_price}
          </p>
        </div>
      </div>
    `
  }

  productVariantsTemplate (variants) {
    const inStockVariants = variants.filter(
      variant => variant.available === 'true',
    )

    return `
      <ul class="mod-ExpandedAddToCart_VariantList">
        ${inStockVariants
          .map(
            variant => `
          <li class="mod-ExpandedAddToCart_VariantItem">
            <product-form class="mod-ExpandedAddToCart_VariantForm">
              <form action="/cart/add" method="post">
                <input type="hidden" name="id" value="${variant.id}">

                <button class="mod-ExpandedAddToCart_VariantTrigger" type="submit data-expanded-add-to-cart-el="variant" data-variant-id="${variant.id}">
                  <div class="mod-ExpandedAddToCart_VariantTitle">
                    ${variant.title}
                  </div>
                  <div class="mod-ExpandedAddToCart_VariantIcon">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18"><path fill="currentColor" fill-rule="evenodd" d="M13.186 6.5H4.76a2 2 0 0 0-1.993 1.834l-.68 8.166h13.82l-.729-8.177A2 2 0 0 0 13.186 6.5Zm2.989 1.734A3 3 0 0 0 13.186 5.5H4.76a3 3 0 0 0-2.99 2.75L1 17.5h16l-.825-9.266Z" clip-rule="evenodd"></path><path fill="currentColor" fill-rule="evenodd" d="M9 2.5A2.5 2.5 0 0 0 6.5 5v3.5h-1V5a3.5 3.5 0 1 1 7 0v3.5h-1V5A2.5 2.5 0 0 0 9 2.5Z" clip-rule="evenodd"></path></svg>
                  </div>
                </button>
              </form>
            </product-form>
          </li>
        `,
          )
          .join('')}
      </ul>
    `
  }
}

window.BAO.ExpandedAddToCart = ExpandedAddToCart

customElements.define('expanded-add-to-cart', ExpandedAddToCart, {
  extends: 'dialog',
})
